import { Mapper } from "../../../../base/utils/mapper";
import { RelationShipModel } from "../../../../domain/models/configuration/relationship.model";
import { RelationShipEntity } from "../entities/relationship.entity";


export class RelationShipImplementationRepositoryMapper extends Mapper<RelationShipEntity, RelationShipModel> {
    mapFrom(param: RelationShipEntity): RelationShipModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RelationShipModel): RelationShipEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}